import React from 'react';
import BaseHtmlContent from '../../Devon/Components/ArticleContent/HtmlContent';
import './HtmlContent.scss';

interface HtmlContentProps {
    content: string;
    loadScripts?: boolean;
}

export default function HtmlContent(props: HtmlContentProps) {
    return (
        <div className='HtmlContent'>
            <BaseHtmlContent {...props} />
        </div>
    );
}
